import { Search, X } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface SearchInputProps extends Omit<React.ComponentProps<typeof Input>, 'value' | 'onChange'> {
  value: string;
  onValueChange: (value: string) => void;
  /** Classes for the positioning wrapper, e.g. width. */
  wrapperClassName?: string;
}

/**
 * A search box with its magnifier and a clear control.
 *
 * `type="button"` on the clear control is load-bearing: a bare <button> inside
 * a form defaults to submit, so clearing a filter would submit the form it
 * sits in.
 */
export function SearchInput({
  value,
  onValueChange,
  className,
  wrapperClassName,
  ...inputProps
}: SearchInputProps) {
  return (
    <div className={cn('relative', wrapperClassName)}>
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground pointer-events-none" />
      <Input
        {...inputProps}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        className={cn('pl-9', value && 'pr-9', className)}
      />
      {value && (
        <button
          type="button"
          aria-label="Clear search"
          onClick={() => onValueChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded text-muted-foreground hover:text-foreground hover:bg-muted/60 transition-colors"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
}
